import './index.less';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {emojiMap, getEmojiURL, splitEmoji} from './emoji';

const EmojiItem = function({data, onClick}){
    let clk = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick(data);
    }
    return (
        <span className="item" onClick={clk}>
            <img className="u-img" src={getEmojiURL(data.value)} />
        </span>
    )
}

class Emoji extends Component{
    constructor(props) {
        super(props);
        this.state = {
            show : false,
            index : 0
        };
        this.emojis = splitEmoji(50);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.changePage = this.changePage.bind(this);
        this.clkEmoji = this.clkEmoji.bind(this);
    }
    show(){
        this.setState({
            show : true
        });
    }
    hide(e){
        if(typeof e != 'undefined'){
            let rootEle = this.rootEle;
            let target = e.target;
            if(rootEle && target == rootEle){
                return;
            }
            if(rootEle && rootEle.contains(target)){
                return;
            }
        }
        this.setState({
            show : false
        });
    }
    changePage(type){
        let length = this.emojis.length;
        return (e) => {
            let {index} = this.state;
            if((type == 'prev' && index == 0) || (type == 'next' && index == length - 1)){
                return;
            }
            let newIndex = index;
            if(type == 'prev'){
                newIndex--;
            }
            else if(type == 'next'){
                newIndex++;
            }
            this.setState({
                index : newIndex
            })
        }
    }
    clkEmoji(data){
        let {onChange} = this.props;
        onChange && onChange(data);
        this.hide();
    }
    renderEmojis(){
        let self = this;
        let {index} = self.state;
        let emojis = self.emojis;
        let emojiNode = emojis[index].map(function(item, n){
            return (<EmojiItem key={"emoji_" + n} onClick={self.clkEmoji} data={item} />)
        });
        return emojiNode;
    }
    componentDidMount(){
        document.body.addEventListener('click', this.hide, false);
    }
    componentWillUnmount(){
        document.body.removeEventListener('click', this.hide, false);
    }
    render(){
        let {show, index} = this.state;
        let {className, offset} = this.props;
        let cls = 'u-emoji';
        if(className){
            cls += ' ' + className;
        }
        let emojis = this.emojis;
        let cstyle;
        if(offset){
            for(let k in offset){
                let value = String(offset[k]);
                if(value.slice(-2) != 'px'){
                    offset[k] = offset[k] + 'px';
                }
            }
            cstyle = offset;
        }
        let contNode;
        if(show){
            contNode = (
                <div className="cont" style={cstyle}>
                    <div className="wrap f-cb">
                        {this.renderEmojis()}
                    </div>
                    <div className="page">
                        <span className="prev" onClick={this.changePage('prev')}></span>
                        <em className="total">{index + 1}/{emojis.length}</em>
                        <span className="next" onClick={this.changePage('next')}></span>
                    </div>
                </div>
            )
        }
        return (
            <span ref={(ref) => {this.rootEle = ref}} onClick={this.show} className={cls}>
                {contNode}
            </span>
        )
    }
}
Emoji.propTypes = {
    className : PropTypes.string,
    onChange : PropTypes.func,
    offset : PropTypes.object  //只支持left,top,bottom,right
}

export default Emoji;


// WEBPACK FOOTER //
// ./client/component/emoji/index.js